import { createCheckInResponsesService } from './check-in-response';
import { createGoalsService } from './goal';
import { createPlansService } from './plan';
import { createPlannedGoalsService } from './planned-goal';

export function createApiService(
  supabaseClient: typeof import('./supabase').supabaseClient,
  getUserId: () => string,
) {
  return {
    plans: createPlansService(supabaseClient, getUserId),
    plannedGoals: createPlannedGoalsService(supabaseClient),
    goals: createGoalsService(supabaseClient, getUserId),
    checkInResponses: createCheckInResponsesService(supabaseClient, getUserId),
  };
}

export type ApiService = ReturnType<typeof createApiService>;
